import React, { Component } from 'react'

import Plyr from './plyr'

class AppraisalIntro extends Component {

  state = {
    show: true,
    fixed: true,
    hoverActive: false,
    pageContext: this.props.pageContext || {},
  }

  render() {
    const data = this.props;
    return (
      <>
        <section className="about-intro" data-color="#FFFFFF">
          <div className="about-intro__inner container">
            <div className='about-intro__content' dangerouslySetInnerHTML={{ __html: data.content }}/>
            <div className="about-intro__video">
              { data.youtube_id &&
                <Plyr
                  type="youtube"
                  ref='player'
                  videoId={ data.youtubeId }
                  urls={{
                    youtube: {
                      api: 'https://noembed.com/embed?url={0}'
                    }
                  }}
                />
              }
              { !data.youtubeId && data.image &&
                <img className="about-intro__image" src={data.image.localFile.publicURL} alt={data.image.alt} />
              }
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default AppraisalIntro
